export default "__VITE_ASSET__DBFUHh6u__"